import { GoogleOAuthProvider } from '@react-oauth/google';
import UserPreferencesPage from './UserPreferencesPage';

const UserPreferencesWrapper = () => {
  const GOOGLE_CLIENT_ID = import.meta.env.VITE_APP_GOOGLE_CLIENT_ID as string;

  if (!GOOGLE_CLIENT_ID) {
    return <UserPreferencesPage />;
  }

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <UserPreferencesPage />
    </GoogleOAuthProvider>
  );
};

export default UserPreferencesWrapper;
